<template>
    <v-layout justify-center>
        <build-feedback-dialog v-on:close="closeFeedbackDialog" :dialog="feedbackDialog"></build-feedback-dialog>
        <v-flex xs4>
            <v-list>
                <building-step
                        :label="$t('form.project.label')"
                        :status="firebaseProjectStatus"
                ></building-step>
                <building-step
                        :label="$t('form.androidApp.label')"
                        :status="androidAppStatus"
                ></building-step>
                <building-step
                        :label="$t('form.iosApp.label')"
                        :status="iosAppStatus"
                ></building-step>
                <building-step
                        :label="$t('form.androidApp.sha')"
                        :status="shaStatus"
                ></building-step>
                <v-list-tile v-if="isSubmitted">
                    <v-list-tile-content>
                        <v-progress-linear v-model="progress"></v-progress-linear>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-flex>
    </v-layout>
</template>

<script>
    import { mapGetters } from "vuex";
    import BuildingStep from './BuildingStep'
    import BuildFeedbackDialog from "./BuildFeedbackDialog";

    export default {
        name: "SubmittedProjectDialog",
        components: { BuildFeedbackDialog, BuildingStep },
        props: {
            status: {
                type: String,
            }
        },
        data() {
          return {
              closeFeedBackDialog: false,
          }
        },
        computed: {
            ...mapGetters({
                firebaseProject: "projects/firebaseProject",
                androidApp: "projects/androidApp",
                iosApp: "projects/iosApp",
                sha: "projects/sha",
            }),
            firebaseProjectStatus() {
                return this.firebaseProject ? this.firebaseProject.buildStatus : '';
            },
            androidAppStatus() {
                return this.androidApp ? this.androidApp.buildStatus : '';
            },
            iosAppStatus() {
                return this.iosApp ? this.iosApp.buildStatus : '';
            },
            shaStatus() {
                return this.sha ? this.sha.buildStatus : '';
            },
            progress() {
                if (this.sha && this.sha.buildStatus !== 'inProgress') return 100;
                if (this.sha) return 75;
                if (this.iosApp) return 50;
                if (this.androidApp) return 25;
                if (this.firebaseProject) return 10;
                return 0;
            },
            feedbackDialog() {
                return this.status === 'resume' && !this.closeFeedBackDialog;
            },
            isSubmitted() {
                return this.status === 'submitted';
            }
        },
        methods: {
            closeFeedbackDialog() {
                this.closeFeedBackDialog = true;
            }
        }
    }
</script>

<style scoped>

</style>
